<template>
	<div class="wh-block reports">
		<h2 class="uk-margin-bottom">Материалы</h2>
		<back></back>
		<div class="wh-block wh-block--reaction" v-if="current_link">
			<div class="reaction">
				<video preload="auto" controls autoplay controlsList="nodownload" @ended="stopReaction">
					<source type="video/mp4" :src="'/storage/app/media' + current_link" id="mp4">
				</video>
				<div class="reaction__stop">
					<button @click="stopReaction">Закрыть видео <span uk-icon="close"></span></button>
				</div>
			</div>
		</div>
		<ul class="uk-grid-match uk-grid-divider" uk-grid>
			<li class="uk-width-1-3@s">
				<div>
					<div v-if="isEmpty(lessons) && isEmpty(mults)">Обучающие видео еще не добавлены</div>
					<div class="reports__block" v-if="!isEmpty(lessons)">
						<h4>Обучающие видео</h4>
						<div class="class_media__block">
							<ul class="uk-nav-default uk-nav-parent-icon" uk-nav>
								<li class="uk-parent" v-for="(l, k) in lessons" :key="l.id">
									<a href="#">{{ k }}</a>
									<ul class="uk-nav-sub">
										<li v-for="sl in l" class="class_media__item" :key="sl.id">
                      <a @click.prevent="playVideo(sl.file_name)" v-if="sl.file_name">
                        <label>
                          <span>{{ sl.title }}</span>
                        </label>
                        <button class="playvid"></button>
                      </a>
                      <div v-if="sl.youtube" uk-lightbox="videoAutoplay:true">
                        <a :href="sl.youtube">
                          <label>
                            <span>{{ sl.title }}</span>
                          </label>
                          <button class="playvid"></button>
                        </a>
                      </div>
										</li>
									</ul>
								</li>
							</ul>
							<hr>
						</div>
					</div>
					<div class="reports__block" v-if="!isEmpty(mults)">
						<h4>Мультсериал</h4>
						<ul class="class_media__items">
							<li v-for="m in mults" class="class_media__item" :key="m.id">
                <a @click.prevent="playVideo(m.file_name)" v-if="m.file_name">
                  <label>
                    <span>{{ m.title }}</span>
                  </label>
                  <button class="playvid"></button>
                </a>
                <div v-if="m.youtube" uk-lightbox="videoAutoplay:true">
                  <a :href="m.youtube">
                    <label>
                      <span>{{ m.title }}</span>
                    </label>
                    <button class="playvid"></button>
                  </a>
                </div>
							</li>
						</ul>
					</div>
				</div>
			</li>
			<li class="uk-width-2-3@s uk-flex-first uk-flex-last@s">
				<div>
					<h4>Обратная связь для родителей</h4>
					<ul uk-accordion v-if="reports.length > 0">
						<li class="" v-for="item in reports" :key="item.id">
							<a class="uk-accordion-title" href="#">Обратная связь от {{ formatDate(item.date) }}</a>
							<div class="uk-accordion-content">
								<div v-if="item.format === 'text' || item.format === 'meeting' || item.format === 'missed'" class="reports__text" v-html="item.desc"></div>
								<div v-if="item.format === 'audio'" class="reports__audio">
									<audio :src="'storage/app/media' + item.file_name" controls></audio>
								</div>
							</div>
						</li>
					</ul>
					<div v-else>Обратной связи пока нет</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from "moment";
import player from "../../addition/player";

export default {
  name: "materials",
  inject: ['http'],
  data() {
    return {
      reports: '',
      mults: [],
      lessons: [],
      current_link: ''
    }
  },
  components: {
    player
  },
  // watch: {
  //   user: 'getMaterials'
  // },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  methods: {
    isEmpty(arr) {
      return _.isEmpty(arr);
    },
    stopReaction() {
      this.current_link = false;
    },
    playVideo(link) {
      this.current_link = link;
    },
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD MMMM YYYY');
    },
    async getMaterials(id) {
      let res = await this.http.post('onGetMaterialsPage', { student_id: id }).then(res => res.data)
      console.log(res)
      this.reports = res.reports;
      this.mults = res.mults;
      this.lessons = res.lessons;
    }
  },
  async mounted() {
    await this.user
    moment.locale('ru');
    this.getMaterials(this.user.id);
  },
  beforeDestroy() {
    this.$emit('destroy app');
  }
}
</script>